import styled from 'styled-components';

export default styled.div`
  display: flex;
  > :first-child {
    flex-grow: 1;
  }
  > :last-child {
    flex-shrink: 0;
  }
`;
